var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdentity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.333 1.667v1.666C8.333 4.253 9.08 5 10 5c.872 0 1.588-.67 1.66-1.523l.007-.144V1.667H15.5c1.105 0 2 .895 2 2v13.5c0 1.104-.895 2-2 2h-11c-1.105 0-2-.896-2-2v-13.5c0-1.105.895-2 2-2h3.833zm2.875 10.5s-.363.314-1.208.314-1.208-.314-1.208-.314c-2.548.312-2.905.804-2.952 2.511-.003.093-.005.127-.006.135v.18c.036.046.712.84 4.166.84 3.454 0 4.13-.794 4.165-.838l.002-.002v-.135c-.002-.003-.003-.033-.005-.123-.04-1.753-.378-2.252-2.954-2.568zM10 6.667c-1.974 0-2.315 1.128-2.315 2.52 0 1.393 1.037 2.521 2.315 2.521s2.315-1.128 2.315-2.52c0-1.393-.34-2.521-2.315-2.521zM10 0c.46 0 .833.373.833.833v2.5c0 .46-.373.834-.833.834-.46 0-.833-.373-.833-.834v-2.5C9.167.373 9.54 0 10 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentity);
export default __webpack_public_path__ + "static/media/identity.2a2af340.svg";
export { ForwardRef as ReactComponent };